import { HostBinding, Directive } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

@Directive()
export abstract class ValueAccessorBase<T> implements ControlValueAccessor {
  @HostBinding('class.sd-component-control') sdComponentControl = true;

  private innerValue: T;

  protected readonly changed = new Array<(value: T) => void>();
  private readonly touched = new Array<() => void>();

  set value(value: T) {
    if (this.innerValue !== value) {
      this.innerValue = value;
      this.changed.forEach(f => f(value));
    }
  }
  get value(): T {
    return this.innerValue;
  }

  /* publics */
  // control value accessor
  writeValue(value: T) {
    this.innerValue = value;
  }

  registerOnChange(fn: (value: T) => void) {
    this.changed.push(fn);
  }

  registerOnTouched(fn: () => void) {
    this.touched.push(fn);
  }

  triggerTouch(_event?: Event): void {
    this.touch();
  }

  // component
  touch() {
    this.touched.forEach(f => f());
  }
}
